<template>
  <div
    v-click-outside="() => ui.showOfficesList = false"
    class="office-picker"
  >
    <div class="office-picker__wrapper">
      <div class="office-picker__chosen">
        <span
          v-if="chosen.length === 0"
          :key="`${id}-not-chosen`"
          class="office-picker__not-chosen"
          @click="ui.showOfficesList = !ui.showOfficesList"
        >
          Clique aqui para escolher os consultórios
        </span>

        <div
          v-else
          :key="`${id}-chosen`"
          class="office-picker__chosen-list"
        >
          <div
            v-for="(office, index) in chosen"
            :key="`${id}-chosen-${index}`"
            class="office-picker__chosen-item"
          >
            <span>{{ office.name }}</span>

            <i
              class="icon icon-cross"
              @click="checkOption(office, chosen)"
            />
          </div>
        </div>
      </div>

      <div
        class="office-picker__arrow"
        @click="ui.showOfficesList = !ui.showOfficesList"
      >
        <i
          :class="ui.showOfficesList && 'office-picker__icon--reverse'"
          class="icon icon-arrow-down office-picker__icon"
        />
      </div>

      <transition name="fade">
        <ul
          v-if="ui.showOfficesList"
          class="office-picker__list"
        >
          <li
            v-for="(office, index) in doctorOffices"
            :key="`${id}-list-item=${index}`"
            :class="chosen.includes(office) && 'office-picker__list-item--selected'"
            class="office-picker__list-item"
            @click="checkOption(office, chosen)"
          >
            <span>{{ office.name }}</span>

            <transition name="fade">
              <i
                v-if="chosen.includes(office)"
                class="icon icon-check"
              />
            </transition>
          </li>

          <li
            v-if="selectAll"
            :class="ui.isSelectedAll && 'office-picker__list-item--selected'"
            class="office-picker__list-item"
            @click="chooseAll()"
          >
            <span>Escolher todos</span>

            <transition name="fade">
              <i
                v-if="ui.isSelectedAll"
                class="icon icon-check"
              />
            </transition>
          </li>
        </ul>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DrOfficePicker',

  model: {
    prop: 'chosenOffices',
    event: 'change'
  },

  props: {
    chosenOffices: {
      type: Array,
      required: false,
      default: () => []
    },

    id: {
      type: String,
      required: false,
      default: () => 'officePicker_'
    },

    selectAll: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },

  data () {
    return {
      chosen: [],
      ui: {
        showOfficesList: false,
        isSelectedAll: false
      }
    }
  },

  computed: {
    ...mapGetters({
      doctorOffices: 'getOffices'
    })
  },

  watch: {
    chosen: {
      deep: true,
      immediate: false,
      handler () {
        this.$emit('change', this.chosen)
      }
    }
  },

  created () {
    this.chosen = [...this.chosenOffices]
  },

  methods: {
    checkOption (item, list) {
      if (list.includes(item)) {
        list.splice(list.indexOf(item), 1)
      } else {
        list.push(item)
      }
    },

    chooseAll () {
      if (this.ui.isSelectedAll) {
        this.chosen = []
      } else {
        this.chosen = [...this.doctorOffices]
      }

      this.ui.isSelectedAll = !this.ui.isSelectedAll
    }
  }
}
</script>
